import React from 'react';
import { fetchGitFrameworksData } from '../../services/b2b-frameworks-apiService';
import ReusableGitInfoPage from '../b2b-common/pages/ReusableGitInfoPage';
import FrameworkSuitteExplorer from './pages/FrameworkSuitteExplorer';
import FrameworksList from './pages/FrameworksList';
import FrameworksExplorerPage from './pages/FrameworksExplorerPage';
import B2BRoutesModule from '../b2b-common/B2BRoutesModule';

const fwsRoutes = [
    {
        path: '/genericfw/explorer',
        element:
            <FrameworkSuitteExplorer
                title={"Frameworks Menu: Generic frameworks explorer."}
                frameworkSuite={"generic"}
            />,
        visibility: 'private'
    },
    {
        path: '/iotfw/explorer',
        element:
            <FrameworkSuitteExplorer
                title={"Frameworks Menu: IOT frameworks explorer."}
                frameworkSuite={"iot"}
            />,
        visibility: 'private'
    },
    {
        path: '/partners/explorer',
        element:
            <FrameworkSuitteExplorer
                title={"Frameworks Menu: Partner's frameworks explorer."}
                frameworkSuite={"partner"}
            />,
        visibility: 'private'
    },
    {
        path: '/vertical/explorer',
        element:
            <FrameworkSuitteExplorer
                title={"Frameworks Menu: Vertical's frameworks explorer."}
                frameworkSuite={"vertical"}
            />,
        visibility: 'private'
    },
    {
        path: '/software/explorer',
        element:
            <FrameworkSuitteExplorer
                title={"Frameworks Menu: Software frameworks explorer."}
                frameworkSuite={"software"}
            />,
        visibility: 'private'
    },
    {
        path: '/genericfw/list',
        element:
            <FrameworksList
                title={"Frameworks Menu: Generic frameworks list."}
                frameworkSuite={"generic"}
            />,
        visibility: 'private'
    },
    {
        path: '/iotfw/list',
        element:
            <FrameworksList
                title={"Frameworks Menu: IOT frameworks list."}
                frameworkSuite={"iot"}
            />,
        visibility: 'private'
    },
    {
        path: '/partners/list',
        element:
            <FrameworksList
                title={"Frameworks Menu: Partner's frameworks list."}
                frameworkSuite={"partner"}
            />,
        visibility: 'private'
    },
    {
        path: '/vertical/list',
        element:
            <FrameworksList
                title={"Frameworks Menu: Vertical's frameworks list."}
                frameworkSuite={"vertical"}
            />,
        visibility: 'private'
    },
    {
        path: '/software/list',
        element:
            <FrameworksList
                title={"Frameworks Menu: Software frameworks list."}
                frameworkSuite={"software"}
            />,
        visibility: 'private'
    },
    { path: '/genericfw/git-info', element: <ReusableGitInfoPage bannerMessage="Frameworks Menu: Generic Frameworks. Show Git commit info." fetchMethod={fetchGitFrameworksData} fetchMethodParams={"generic"} />, visibility: 'private' },
    { path: '/iotfw/git-info', element: <ReusableGitInfoPage bannerMessage="Frameworks Menu: IOT Frameworks. Show Git commit info." fetchMethod={fetchGitFrameworksData} fetchMethodParams={"iot"} />, visibility: 'private' },
    { path: '/verticalfw/git-info', element: <ReusableGitInfoPage bannerMessage="Frameworks Menu: Vertical Frameworks. Show Git commit info." fetchMethod={fetchGitFrameworksData} fetchMethodParams={"vertical"} />, visibility: 'private' },
    { path: '/partnerfw/git-info', element: <ReusableGitInfoPage bannerMessage="Frameworks Menu: Partner Frameworks. Show Git commit info." fetchMethod={fetchGitFrameworksData} fetchMethodParams={"partner"} />, visibility: 'private' },
    { path: '/softwarefw/git-info', element: <ReusableGitInfoPage bannerMessage="Frameworks Menu: Software Frameworks. Show Git commit info." fetchMethod={fetchGitFrameworksData} fetchMethodParams={"software"} />, visibility: 'private' },
    { path: '/fws-explorer', element: <FrameworksExplorerPage />, visibility: 'private' },
    { path: '*', element: <h1>Not Found</h1> }
];

const B2BFrameworks = () => {
    return <B2BRoutesModule routes={fwsRoutes} />;
}

export default B2BFrameworks;